import { SpaceDetail } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const SpaceDetailPage: FC = () => {
    const { t } = useTranslation();

    const translations = {
        metaTitle: t('space-detail-page.metatags.title'),
        description: t('space-detail-page.metatags.description'),
        title: t('space-detail-page.message.title'),
        subtitle: t('space-detail-page.message.subtitle'),
        otherSubtitle: t('space-detail-page.message.otherSubtitle'),
        button: t('space-detail-page.message.button'),
        imageAlt: t('space-detail-page.image.alt'),
    };

    useSEOMetatags({
        title: translations.metaTitle,
        description: translations.description,
        url: SITE_URLS.spaceDetail,
        index: false,
    });

    return <SpaceDetail />;
};
